import { isEqual } from 'lodash-es'
import { LAYOUTSTATE } from '..'
import { TLayoutState, TPortalState } from '../../../types/state'
import { LayoutEvent } from '../../constants/enums'
import { pubSubLayout } from '../pubSub'

const setPortalState = (portalState: TPortalState, immediate = true) => {
    if (isEqual(LAYOUTSTATE.portal, portalState)) return
    LAYOUTSTATE.portal = portalState
    pubSubLayout.emit(LayoutEvent.PORTAL_CHANGE, portalState, immediate)
}

export const updatePortalState = (
    portalState: Partial<TPortalState>,
    immediate = true,
) => {
    if (!portalState || typeof portalState !== 'object') return
    const nextPortalState = { ...LAYOUTSTATE.portal, ...portalState }
    setPortalState(nextPortalState, immediate)
}

export const setLayoutState = (layoutState: TLayoutState) => {
    if (isEqual(LAYOUTSTATE.layout, layoutState)) return
    LAYOUTSTATE.layout = layoutState
    pubSubLayout.emit(LayoutEvent.LAYOUT_CHANGE, layoutState, true)
}
